import './front/accordion.js';
import './front/anchor-threshold.js';
import './front/external-links.js';
import './front/loop-fade.js';
import './front/menu-offcanvas.js';
import './front/menu-sticky.js';
import './front/menu-sub.js';
import './front/outdated-browser.js';
import './front/glide.js';
import './front/sticky-pictures-transition.js';
import './front/sticky-timeline.js';

const htmlElement = document.querySelector('html');
htmlElement.classList.remove('no-js');
htmlElement.classList.add('js');
